import React, { useMemo } from 'react';
import PropTypes from 'prop-types';

const StatusBadge = ({ status }) => {
  // Base and common badge styles
  const baseClasses = 'inline-block font-medium text-xs uppercase rounded-md';
  const commonBadgeClasses = 'py-[4px] px-3';

  const statusMap = {
    // Text-based statuses
    active: { text: 'Active', classes: 'bg-green-400' },
    inactive: { text: 'Inactive', classes: 'bg-green-500' },
    completed: { text: 'Paid', classes: 'bg-green-600 text-white' },
    pending: { text: 'Pending', classes: 'bg-yellow-500 text-white' },
    created: { text: 'Created', classes: 'bg-blue-500' },
    failed: { text: 'Failed', classes: 'bg-red-500 text-white' },
    expired: { text: 'Expired', classes: 'bg-gray-500 text-white' },
    canceled: { text: 'Canceled', classes: 'bg-gray-500 text-white' },
    open: { text: 'Open', classes: 'bg-gray-500 text-white' },

    transfer_completed: {
      text: 'Completed',
      classes: 'bg-[#A7D760] text-brandBlue',
    },
    transferred: {
      text: 'Transferred',
      classes: 'bg-[#A7D760] text-brandBlue',
    },
    transfer_pending: { text: 'Pending', classes: 'bg-[#3D4CB2] text-white' },
    draft: { text: 'Draft', classes: 'bg-yellowBadge text-white' },
    yes: { text: 'Yes', classes: 'bg-green-400 text-brandBlue' },
    no: { text: 'No', classes: 'bg-[#F59342] text-brandBlue' },
    failure: { text: 'Failure', classes: 'bg-[#969696] text-white' },
    // Investment types
    bond: {
      text: 'Bond',
      classes:
        'bg-yellow-500 text-brandBlue py-1 px-3 rounded inline-block text-sm border-brandBlue',
    },
    equity: {
      text: 'Equity',
      classes:
        'text-sm font-medium py-1 px-3 rounded inline-block border border-brandBlue text-brandBlue',
    },
    // Project-specific
    project_draft: {
      text: 'Draft',
      classes:
        'bg-yellowBadge text-brandBlue inline-block px-2 rounded-md font-semibold',
    },
    project_published: {
      text: 'Published',
      classes:
        'bg-GreenColor text-brandBlue inline-block px-2 rounded-md font-semibold',
    },

    // Numeric status codes
    0: { text: 'Pending', classes: 'text-yellow-500' },
    1: { text: 'Completed', classes: 'text-green-700' },
    2: { text: 'Rejected', classes: 'text-red-500' },
    3: { text: 'In-process', classes: 'text-yellow-600' },
    4: { text: 'In Review', classes: 'text-yellow-600' },
  };

  // Normalize the status value (in case it's a number or string)
  const normalizedStatus = useMemo(() => {
    if (typeof status === 'string') return status.toLowerCase();
    return status; // Return as is if it's a number
  }, [status]);

  const badge = statusMap[normalizedStatus] || {
    text: '--',
    classes: 'bg-gray-200 text-gray-600', // Default fallback
  };

  return (
    <div className={`${baseClasses} ${commonBadgeClasses} ${badge.classes} `}>
      {badge.text}
    </div>
  );
};

StatusBadge.propTypes = {
  status: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
};

export default StatusBadge;
